export const GUEST_DETAIL_TEXT = {
  BUTTON_BACK: 'Back',
  BUTTON_EDIT: 'Edit',
  BUTTON_PDF: 'PDF',
  BUTTON_AUDIT: 'Audit',
  BUTTON_CLOSE: 'Close',
  BUTTON_CANCEL: 'Cancel',
  SECTION_GUEST_DETAILS: 'Guest Details',
  SECTION_STAY_DETAILS: 'Stay Details',
  SECTION_FINANCIALS: 'Financials',
  SECTION_ROOM_ALLOCATION: 'Room Allocation',
  SECTION_DOCUMENTS: 'Documents & Payment Proof',
  AUDIT_TITLE_PREFIX: 'Audit Trail',
  NO_ROOM_ALLOCATIONS: 'No room allocations found.',
  NO_DOCUMENTS: 'No documents uploaded yet.',
  NO_AUDIT_RECORDS: 'No audit records found.',
  NO_FIELD_CHANGES: 'No field changes recorded.',
  DRIVER_CHARGE: 'Driver Charge',
  DOCUMENT_DELETE_TOOLTIP: 'Delete (admin only)',
  VIEWER_PREVIOUS: 'Previous',
  VIEWER_NEXT: 'Next',
  VIEWER_FULLSCREEN: 'Fullscreen',
  VIEWER_EXIT_FULLSCREEN: 'Exit fullscreen',
} as const;

export const GUEST_DETAIL_MESSAGE = {
  LOAD_BOOKING_FAILED: 'Failed to load booking.',
  DELETE_DOCUMENT_CONFIRM: 'Delete this document permanently?',
  DOCUMENT_DELETED: 'Document deleted successfully.',
  DOCUMENT_DELETE_FAILED: 'Failed to delete document.',
} as const;

export const GUEST_DETAIL_FIELD_LABEL = {
  NAME: 'Name',
  PHONE: 'Phone',
  EMAIL: 'Email',
  ADDRESS: 'Address',
  BOOKED_BY: 'Booked By',
  REMARKS: 'Remarks',
  STATUS: 'Status',
  CANCELLATION_REASON: 'Cancellation Reason',
  IS_REFUNDED: 'Is Refunded',
  REFUNDED_AMOUNT: 'Refunded Amount',
  CHECK_IN: 'Check-in',
  CHECK_OUT: 'Check-out',
  NO_OF_DAYS: 'No. of Days',
  ADULTS: 'Adults',
  CHILDREN: 'Children',
  DRIVERS: 'Drivers',
  TOTAL_MEMBERS: 'Total Members',
  CREATED_BY: 'Created By',
  CREATED_ON: 'Created On',
  LAST_MODIFIED: 'Last Modified',
  MODIFIED_BY: 'Modified By',
  TOTAL_AMOUNT: 'Total Amount',
  ADVANCE_PAID: 'Advance Paid',
  REMAINING: 'Remaining',
  DIFFERENCE: 'Difference',
  REASON: 'Reason',
  NOTE: 'Note',
} as const;

export const GUEST_DETAIL_TABLE_LABEL = {
  ROOM_TYPE: 'Room Type',
  ROOM_NO: 'Room No.',
  COUNT: 'Count',
  ADULTS: 'Adults',
  CHILDREN: 'Children',
  AMOUNT_PER_PERSON: 'Amt/Person',
} as const;

export const GUEST_DETAIL_AUDIT_LABEL = {
  BY: 'By',
  FIELD: 'Field',
  OLD_VALUE: 'Old Value',
  NEW_VALUE: 'New Value',
  VALUE: 'Value',
  DATE: 'Date',
  ROOM: 'Room',
  DRIVER_CHARGE: 'Driver charge',
  AMOUNT_PER_PERSON: 'Amount/Person',
  STAY_DATE: 'Stay date',
  CHANGED: 'Changed',
  ADDED_REMOVED: 'Added/Removed',
} as const;

export const GUEST_DETAIL_BOOLEAN_LABEL = {
  YES: 'Yes',
  NO: 'No',
} as const;

export const GUEST_DETAIL_REFUND_STATUS = {
  YES: 'yes',
  NO: 'no',
} as const;

export const GUEST_DETAIL_FALLBACK = {
  EMPTY: '-',
  EMPTY_DASH: '—',
  OTHER_ROOM_TYPE: 'Other',
} as const;

export const GUEST_DETAIL_CONFIRMATION = {
  BOOKING_CONFIRMATION: 'booking confirmation',
  SEND_PREFIX: 'Send a',
  WHATSAPP_MESSAGE_SUFFIX: 'WhatsApp message to',
  EMAIL_SUFFIX: 'email to',
  STATUS_ALERT_PREFIX: 'This will notify the guest that booking',
  STATUS_ALERT_MIDDLE: 'is',
  ACKNOWLEDGEMENT_PREFIX: 'I understand this will send a',
  ACKNOWLEDGEMENT_SUFFIX: 'notification to the guest.',
} as const;
